import { Button } from "../../../../components/ui/button";
import TwoFactorAuth from "../../TwoFactorAuth";
import { useStepper } from "../../../../components/ui/stepper";
import { useNavigate } from "react-router-dom";

const Step1 = () => {
  const { nextStep } = useStepper();
  const navigate = useNavigate();

  return (
    <div>
      <TwoFactorAuth change={true} handle2FAChange={() => nextStep()}/>
      <div className="flex gap-2 w-full items-center justify-end">
        {/* <Button type="submit" onClick={() => nextStep()}>
          Next
        </Button> */}
        <Button variant="outline" size="default" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>
    </div>
  );
};

export default Step1;
